export function getMarkers(markerPositions, desktop = false) {
  // eslint-disable-next-line no-shadow
  return markerPositions.map(({ text, params, id }) => {
    const [cx, cy] = desktop && params.desktop ? params.desktop.marker : params.mobile.marker
    const [x, y] = desktop && params.desktop ? params.desktop.text : params.mobile.text
    const line = desktop && params.desktop ? params.desktop.line : params.mobile.line
    return { text, cx, cy, x, y, id, line }
  })
}
